import { PayPalButtons, PayPalButtonsComponentProps, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { Skeleton } from "antd";

const CustomPaypalButtons: React.FC<PayPalButtonsComponentProps> = ({ ...props }) => {
	const [{ isPending }] = usePayPalScriptReducer();

	return (
		<>
			<Skeleton loading={isPending}>
				<PayPalButtons {...props} />
			</Skeleton>
		</>
	);
};

export default CustomPaypalButtons;
